import { render, staticRenderFns } from "./detailsservice.vue?vue&type=template&id=676306ab&scoped=true&"
import script from "./detailsservice.vue?vue&type=script&lang=js&"
export * from "./detailsservice.vue?vue&type=script&lang=js&"
import style0 from "./detailsservice.vue?vue&type=style&index=0&id=676306ab&prod&lang=less&scoped=true&"
import style1 from "./detailsservice.vue?vue&type=style&index=1&id=676306ab&prod&lang=css&"
import style2 from "./detailsservice.vue?vue&type=style&index=2&id=676306ab&prod&lang=less&scoped=true&"
import style3 from "./detailsservice.vue?vue&type=style&index=3&id=676306ab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676306ab",
  null
  
)

export default component.exports